import Dashboard from "./Dashboard.js";

export default Dashboard;
